import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications, useFormErrorHandler } from 'core/http';
import { VehicleSchema } from 'core/schemas/vehicle';
import { Vehicle } from 'core/types/vehicle';

export default function useVehicle(id: number) {
  const showErrorNotification = useErrorNotifications();
  const handleFormErrors = useFormErrorHandler();
  const [vehicle, setVehicle] = useState<Vehicle>();

  useEffect(() => {
    client()
      .get<Vehicle>(`vehicles/${id}`)
      .then(response => response.data)
      .then(setVehicle)
      .catch(showErrorNotification);
  }, [id, showErrorNotification]);

  const update = useCallback(
    (payload: VehicleSchema) => {
      return client()
        .patch<Vehicle>(`vehicles/${id}`, payload)
        .then(response => response.data)
        .then(setVehicle)
        .catch(handleFormErrors);
    },
    [handleFormErrors, id]
  );

  return { vehicle, update };
}
